import {
  Box,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Palette } from "@material-ui/icons";
import React, { useEffect, useState } from 'react';
import { DateFormatter } from "../../../../../Common/Utils/common_utils";
import MaterialTable from "material-table";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    "& .MuiLinearProgress-colorPrimary": {
      backgroundColor: "rgb(234 234 234)",
    },
    "& .MuiLinearProgress-barColorPrimary": {
      // backgroundColor: "#981B1E"
    },
  },
  root: {
    backgroundColor: "#F7F7F7",
    "& .MuiListItem-root.Mui-selected": {
      backgroundColor: "#981B1E1A",
    },
  },
  large: {
    width: theme.spacing(13),
    height: theme.spacing(13),
  },
  textSecondary: {
    color: theme.palette.secondary.main,
  },
}));

const SessionDetails = (props) => {
  const classes = useStyles();
  const { sessionDetail } = props;
  let totalTime = 0;
  if(parseInt(sessionDetail?.completion_percentage.split(" ")[0])){
    if(parseInt(sessionDetail?.completion_percentage.split(" ")[0]) < 100 ){
      totalTime = parseInt(sessionDetail?.completion_percentage.split(" ")[0])
    }else{
      totalTime=100;
    }
  }
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const columns = [
    { field: "session_name", title: "Session name" },
    { field: "session_date", title: "Session date" },
    { field: "session_duration", title: "Session duration" },
    { field: "stakeholders_involved", title: "Stakeholders involved",render: rowData => rowData.stakeholders_involved && rowData.stakeholders_involved.toString() },   
    { field: "session_notes", title: "Session notes" },
  ];
  return (
    <Box classes={{ root: classes.wrapper }}>
      <Grid container direction="row">
        <Grid item xs={12}>
          <Grid container direction="row">
            <Grid item xs={4}>
              <Typography variant="subtitle1" className={classes.textSecondary}>
                <Box textAlign="left" mt={2} fontWeight="fontWeightBold">
                  Total time:{" "}
                  {sessionDetail?.total_time
                    ? `${sessionDetail?.total_time} hours`
                    : "0 hours"}
                </Box>
              </Typography>
              <Box my={1}>
                <LinearProgress
                  variant="determinate"
                  value={totalTime}
                />
              </Box>
              <Typography variant="subtitle1" className={classes.textSecondary}>
                <Box
                  textAlign="left"
                  mr={1}
                  display="inline"
                  fontWeight="fontWeightBold"
                >
                  {sessionDetail?.completion_time || 0}
                </Box>
                <Box textAlign="left" display="inline">
                  completed
                </Box>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={12}>
          <Typography variant="subtitle1">
            <Box textAlign="left" mt={2} fontWeight="fontWeightBold">
              Contracting session (up to 2hrs with 30 mins LM attendance)
            </Box>
          </Typography>
          <Typography variant="h2" style={{ color: "#707070CC" }}>
            <Box textAlign="left" mt={1}>
              N/A
            </Box>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1">
            <Box textAlign="left" mt={2} fontWeight="fontWeightBold">
              Verbal 360º pre-coaching feedback (6 - 8)
            </Box>
          </Typography>
          <Typography variant="h2" style={{ color: "#707070CC" }}>
            <Box textAlign="left" mt={1}>
              N/A
            </Box>
          </Typography>
        </Grid> */}
        <Grid item xs={12}>
          <Typography variant="subtitle1">
            <Box
              textAlign="left"
              my={2}
              fontWeight="fontWeightBold"
              color={"#EF7000"}
            >
              Session details
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {/* <Box border={1} borderColor="#E2E2E3" p={1}>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item xs={2}>
                <Typography variant="h2">
                  <Box
                    textAlign="left"
                    fontWeight="fontWeightBold"
                    color={"#077F83"}
                  >
                    Session
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h2">
                  <Box
                    textAlign="left"
                    fontWeight="fontWeightBold"
                    color={"#077F83"}
                  >
                    Session date
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h2">
                  <Box
                    textAlign="left"
                    fontWeight="fontWeightBold"
                    color={"#077F83"}
                  >
                    Session duration
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="h2">
                  <Box
                    textAlign="left"
                    fontWeight="fontWeightBold"
                    color={"#077F83"}
                  >
                    Stakeholders involved
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="h2">
                  <Box
                    textAlign="left"
                    fontWeight="fontWeightBold"
                    color={"#077F83"}
                  >
                    Session notes
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Box> */}
          {/* {sessionDetail?.session_details?.map((data, index) => {
            return (
              <Box border={1} borderColor="#E2E2E3" p={1}>
                <Grid container direction="row" alignItems="center" spacing={2}>
                  <Grid item xs={2}>
                    <Typography variant="h2">
                      <Box textAlign="left">{data?.session_name || "-"}</Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography variant="h2">
                      <Box textAlign="left">
                        {DateFormatter(data?.session_date) || "-"}
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography variant="h2">
                      <Box textAlign="left">
                        {data?.session_duration || "-"}
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="h2">
                      <Box textAlign="left">
                        {data?.stakeholders_involved[0] || "-"}
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="h2">
                      <Box textAlign="left">{data?.session_notes || "-"}</Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            );
          })} */}
            <MaterialTable
            title=""
            classes={{
              root: classes.root,
              actions: classes.actions,
            }}
            options={{
              headerStyle: {
                color: "#077F83",
                marginTop: "10px",
                position: "sticky",
                top: "0"
              },
              maxBodyHeight: "600px" ,
              actionsColumnIndex: -1,
              search: false,
              actionsCellStyle: {},
              page: page,
              pageSize: pageSize,
              emptyRowsWhenPaging: false,
            //   total: totalCount,
          
            }}
          
            columns={columns}
            data={sessionDetail?.session_details}
            page={page}
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(pageSize) => {
              setPageSize(pageSize);
            }}
            localization={{
              header: {
                actions: "",
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SessionDetails;
